import { html, LitElement } from "lit-element";
import { classMap } from "lit-html/directives/class-map";
import { styleMap } from "lit-html/directives/style-map";
export class BlackOut extends LitElement {
    constructor() {
        super(...arguments);
        this.on = false;
    }
    static get properties() {
        return {
            on: { type: Boolean },
        };
    }
    createRenderRoot() {
        return this;
    }
    render() {
        const klass = {
            "o-0": !this.on,
        };
        const style = {
            transition: "0.8s opacity linear",
        };
        return html `<div
      class="absolute absolute--fill bg-black ${classMap(klass)}"
      style="${styleMap(style)}"
    >
      <jh-render-debug name="black-out"></jh-render-debug>
    </div>`;
    }
}
customElements.define("jh-black-out", BlackOut);
//# sourceMappingURL=blackOut.js.map